export class Changepwd {
  email:any;
  oldpassword: any;
  newpassword: any;
  confirmnewpassword: any;
}
